module.exports = __webpack_public_path__ + "static/media/social-media-svgrepo-com (1).0f8885de.svg";